import React from "react";
import Modal from "../modal/modal";

import "./modalApprove.scss";

interface CommentModalInter {
  onClose: () => void;
  open: boolean;
}

const ModalApprove = (props: CommentModalInter) => {
  const { onClose, open } = props;
  return (
    <Modal className="a-commentmodal-container" open={open} onClose={onClose}>
      <div className="a-commentmodal-modal">
        <div className="a-commentmodal-contents">
          <i
            className="a-commentmodal-contents--close icon-close"
            onClick={() => onClose()}
          />
          <p className="a-commentmodal-contents--title">Comentario</p>
          <div className="a-commentmodal-contents--icon">
            <p className="icon-comment-alt1 icon-below"></p>
            <p className="icon-comment-alt1 icon-above"></p>
            <p className="icon-check-circle1 icon-check"></p>
          </div>
          <p className="a-commentmodal-contents--description">
            Antes de publicarlo, el comentario será revisado y valorado por el
            equipo de Bibliotecas Comfama.
          </p>
          <button
            className="a-commentmodal-contents--confirm"
            onClick={() => onClose()}
          >
            ENTENDIDO
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default ModalApprove;
